import iconDash from 'assets/img/dashboard.svg';
import iconLocals from 'assets/img/locations-icon.svg';
import iconTasks from 'assets/img/tasks-icon.svg';
import iconHelp from 'assets/img/help-icon.svg';

import { routes } from './routes';

export const Menus = [
  {
    label: 'Painel',
    srcIcon: iconDash,
    to: routes.dashboard,
  },
  {
    label: 'Pedidos',
    srcIcon: iconTasks,
    to: routes.taskList,
  },
  {
    label: 'Locais',
    srcIcon: iconLocals,
    to: routes.locals,
  },
  // {
  //   label: 'Ajuda',
  //   srcIcon: iconHelp,
  //   to: '/ajuda',
  // },
];
